import type { HistoryEventDirection, HistoryPageCursor } from "./types";

// Every row on a page runs the revert check against live rows, so pages stay short.
export const HISTORY_PAGE_SIZE = 15;

export const NEWEST_PAGE: HistoryPageCursor = { page: 1, snapshotMaxId: null };

// Names the revert in React Query's mutation cache, so only a running revert blocks the next one.
export const REVERT_MUTATION_KEY: readonly string[] = [
  "quantitySurveyorHistory",
  "revert",
];

// A plan's undo session ends once nothing has looked at it for this long.
export const OWN_UNDO_SESSION_GC_TIME_MS = 30 * 60 * 1000;

export const SHORTCUT_LABEL_KEYS: Record<HistoryEventDirection, string> = {
  undo: "smartSurveyor.history.undoShortcut",
  redo: "smartSurveyor.history.redoShortcut",
};

export const SHORTCUT_KEYS_KEYS: Record<
  "mac" | "other",
  Record<HistoryEventDirection, string>
> = {
  mac: {
    undo: "smartSurveyor.history.undoKeysMac",
    redo: "smartSurveyor.history.redoKeysMac",
  },
  other: {
    undo: "smartSurveyor.history.undoKeys",
    redo: "smartSurveyor.history.redoKeys",
  },
};

export const NOTHING_LABEL_KEYS: Record<HistoryEventDirection, string> = {
  undo: "smartSurveyor.history.nothingToUndo",
  redo: "smartSurveyor.history.nothingToRedo",
};
